/* eslint-disable @typescript-eslint/camelcase */
import createAuth0Client from "@auth0/auth0-spa-js";
import Auth0Client from "@auth0/auth0-spa-js/dist/typings/Auth0Client";
import axios from "axios";
import { RoleNames } from "./RoleNames";

export default class AuthUtil {
  public loggedIn = false;
  public user: any = null;
  public auth0Client!: Auth0Client;

  public async init(options: Auth0ClientOptions): Promise<void> {
    this.auth0Client = await createAuth0Client(options);
  }

  public async login(path: string): Promise<void> {
    console.log(await this.auth0Client.isAuthenticated());
    if (await this.auth0Client.isAuthenticated()) {
      const token = await (await this.auth0Client.getIdTokenClaims()).__raw;
      axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
      console.log(token);
      console.log(await this.auth0Client.getUser());
      console.log(await this.auth0Client.getIdTokenClaims());
      this.loggedIn = true;
      this.user = this.parseUser(await this.auth0Client.getUser());
    } else {
      return await this.auth0Client.loginWithRedirect({
        redirect_uri: window.location.origin,
        ui_locales: "de",
        appState: { path }
      });
    }
  }
  private parseUser(user: any): any {
    const result = user;
    if (user) {
      result.roles = user["http://pitchapi.de/roles"];
    }

    return result;
  }

  public async checkLoggedIn(): Promise<boolean> {
    const result = await this.auth0Client.isAuthenticated();
    return result;
  }

  public async handleRedirectCallback(): Promise<RedirectLoginResult> {
    return await this.auth0Client.handleRedirectCallback();
  }

  public checkUserRoles(...roles: string[]): boolean {
    if (roles && this.user && this.user.roles) {
      const userRoles = this.user.roles as string[];
      if (userRoles.includes(RoleNames.ADMIN)) {
        return true;
      }
      for (const role of roles) {
        if (userRoles.includes(role)) {
          return true;
        }
      }
    }
    return false;
  }

  public async logout() {
    return this.auth0Client.logout({
      returnTo: window.location.origin
    });
  }
}
